import React from 'react';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'es', label: 'ES' },
];

export default function LanguageSelector({ locale, onChange }) {
  return (
    <div className="fixed top-4 right-4 z-50 flex gap-1 bg-white/10 backdrop-blur-md rounded-full p-1">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => onChange(lang.code)}
          className={`px-3 py-1 rounded-full text-sm font-bold transition-all ${
            locale === lang.code
              ? 'bg-accent text-white'
              : 'text-white/60 hover:text-white'
          }`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
